import jQuery from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import Gallery from "./gallery/gallery";

export default function (gallery) {
	let elements = jQuery(gallery).children();
	let items = [];

	elements.each(function () {
		const el = jQuery(this);
		const type = el.data('type') || 'image';

		if(type === 'image') {
			items.push({
				type: type,
				lores: el.data('lores'),
				hires: el.data('hires'),
				zoom: el.data('zoom'),
				alt: el.data('alt')
			});
		} else if(type === 'yt') {
			items.push({
				type: type,
				thumb: el.data('thumb'),
				url: el.data('url'),
				ytToken: el.data('yt-token'),
				alt: el.data('alt')
			});
		}
	});

	ReactDOM.render(<Gallery items={items} />, gallery);
};

